module.exports = __webpack_public_path__ + "b44c85bdb313e1fd737f5cf8c47bc9b7.pdf";